

import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}
    
     function LetterUnread({ color }: Props): ReactElement {

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3346 8.33398C18.35 8.93987 18.3346 9.21251 18.3346 10.0007C18.3346 13.1433 18.3346 14.7147 17.3583 15.691C16.382 16.6673 14.8107 16.6673 11.668 16.6673H8.33464C5.19194 16.6673 3.62059 16.6673 2.64428 15.691C1.66797 14.7147 1.66797 13.1433 1.66797 10.0007C1.66797 6.85795 1.66797 5.28661 2.64428 4.3103C3.62059 3.33398 5.19194 3.33398 8.33464 3.33398H10.8346" stroke={color ? color : "#424242"} strokeLinecap="round"/>
<path d="M5 6.66602L6.79908 8.16525C8.32961 9.44069 9.09488 10.0784 10 10.0784C10.9051 10.0784 11.6704 9.44069 13.2009 8.16525" stroke={color ? color : "#155a9e"} strokeLinecap="round"/>
<circle cx="15.832" cy="4.16602" r="2.5" stroke={color ? color : "#155a9e"}/>
</svg>
    );
}

export default LetterUnread;